import React from 'react';
import { Rocket } from 'lucide-react';
import { Wrapper, CTAButton } from './styles';

const handleTryNewVersion = () => {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `app_version=v2; path=/; max-age=31536000; SameSite=Lax${secure}`;
    window.location.reload();
};


const TryNewVersionButton: React.FC = () => {
    return (
        <Wrapper>
            <CTAButton type="button" onClick={handleTryNewVersion}>
                <Rocket />
                Testar nova versão
            </CTAButton>
        </Wrapper>
    );
};

export default TryNewVersionButton;
